module.exports = __webpack_public_path__ + "img/gr_btn.4a8b5aa8.png";